module.exports = __webpack_public_path__ + "static/media/Mereoleona-Script-Alt.47dc244c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Mereoleona-Script-Alt.woff
// module id = 2351
// module chunks = 50